<template>
  <div class>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        <v-icon class="icon">fa-plus</v-icon>ADD SENSO LEARN CONTENT
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="s3Uploading" color="primary" loading></v-btn>
      <v-btn v-else fab small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
           <v-switch
            v-model="improve.all_content"
              label="ALL CONTENT"
              color="primary" @change="toggleOnOff(improve.all_content)"
            ></v-switch>
            
              <!--<v-switch 
              v-model="improve.leg_regulation"
              label="LEGISLATION & REGULATION"
              color="primary" @change="toggleChange(improve.leg_regulation)"
              
            ></v-switch>
            
            
              <v-switch 
              v-model="improve.people_relationship"
              label="PEOPLE & RELATIONSHIPS"
              color="primary" @change="toggleChange(improve.people_relationship)"
              
            ></v-switch>
            
             <v-switch 
              v-model="improve.online_safety"
              label="ONLINE & OFFLINE SAFETY"
              color="primary" @change="toggleChange(improve.online_safety)"
              
            ></v-switch>
            
            <v-switch 
              v-model="improve.digital_skills"
              label="DIGITAL & IT SKILLS"
              color="primary" @change="toggleChange(improve.digital_skills)"
              
            ></v-switch>
           
            <v-switch 
              v-model="improve.management_leadership"
              label="MANAGEMENT & LEADERSHIPS"
              color="primary" @change="toggleChange(improve.management_leadership)"
             
            ></v-switch>
            
            <v-switch 
              v-model="improve.wfh_toolkit"
              label="WORKING FROM HOME TOOLKIT"
              color="primary" @change="toggleChange(improve.wfh_toolkit)"
            
            ></v-switch>
            -->
            
            <v-select :error-messages="messages.no_of_users"
              v-model="improve.no_of_users"
              :items="partnerLevelList"
              item-text="name"
              item-value="id"
              label="# OF USERS"
              class="mt-4"
              hint="select no of users"
              persistent-hint
              roles
              v-on:change="changePrice(improve.no_of_users,improve)"
              attach
            ></v-select>
          
           <v-text-field :error-messages="messages.annual_price"
		          v-model="improve.annual_price"
              label="ANNUAL PRICE"
              type="text" readonly
            ></v-text-field>
            
          </v-form>
           <v-text-field v-model="total" type="hidden"></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn color="primary" class="mr-1" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" @click="addImproveContent">CONFIRM</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import improveAPI from "@/api/superadmin.js";

//import companyAPI from "@/api/company.js";

export default {
  name: "AddPartner",
 props: {
    id: {
      type: String,
      default: null
    },
    companyId: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      partner: {

      },
      content_type:'test',
      improve:{},
      groups: [],
      messages: {},
      content_type:0,
      total:0,
      partnerLevelList: [
        {
          name: "1-20",
          id: 20
        },
        {
          name: "21-50",
          id: 50
        },
        
         {
          name: "51-100",
          id: 100
        },
        
         {
          name: "101-250",
          id: 250
        },
        {
          name: "250-500",
          id: 500
        },
        
      ],
      partnerCompanyList: [],
      isLevelTier2: false,
      successMessage: "SENSO LEARN Content Successfully Added.",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
    loading:false
    };
  },
  mounted() {
    this.getImproveContent(this.companyId);
    //this.getPartnerCompanyList();
  },
  methods: {
    closePanel() { 
      this.$emit("closePanel", {});
      EventBus.$emit("USERS_UPDATED", this.params);
      //this.$router.go();
      //this.$router.push('/super-admin/companies');
    },
    addImproveContent() {
       this.loading = true;
     // alert(this.id);
      //alert(this.companyId);
      improveAPI
        .createEdifyImproveContent(this.id,this.companyId,this.improve)
        .then(() => {
          this.closePanel();
          EventBus.$emit("USERS_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    getImproveContent(id) {
       this.loading = true;//alert(this.params);
       improveAPI.getImproveContent(id+'?content_type=0').then((response)=>{
          this.improve = response.data.data;
          if(this.improve.all_content){
            this.total = 6;
          }
          this.loading = false;//alert(this.params);
       }).catch(err=>{
          this.loading = false;//alert(this.params);
       });
    },
    toggleOnOff(all_content){
        let bindingList = {20:400,50:800,100:1300,250:2600,500:4000};
          this.improve.annual_price = '';
          this.improve.leg_regulation = false;
          this.improve.people_relationship = false;
          this.improve.online_safety = false;
          this.improve.digital_skills = false;
          this.improve.management_leadership = false;
          this.improve.wfh_toolkit = false;
        if(all_content){
          this.improve.leg_regulation = true;
          this.improve.people_relationship = true;
          this.improve.online_safety = true;
          this.improve.digital_skills = true;
          this.improve.management_leadership = true;
          this.improve.wfh_toolkit = true;
          this.total = 6;
        }else{
          this.total = 0;
        }
        
        this.improve.annual_price = bindingList[this.improve.no_of_users];
    },
    changePrice(value,improve){ 
     
      let bindingList = {20:400,50:800,100:1300,250:2600,500:4000};
      let bindingListChange = {20:135,50:200,100:435,250:865,500:1335};
      let counter = 0;
      /*if(improve.leg_regulation){
        counter +=1;
      }if(improve.people_relationship){
        counter +=1;
      }if(improve.online_safety){
        counter +=1;
      }if(improve.digital_skills){
        counter +=1;
      }if(improve.management_leadership){
        counter +=1;
      }if(improve.wfh_toolkit){
        counter +=1;
      }*/
      //this.total = counter;
      this.total = 6;
      if(this.total>5){
        this.improve.annual_price = bindingList[value];
      }else{
         this.improve.annual_price = bindingListChange[value]*counter;
      }
      
      //alert(this.improve.annual_price);
      //if(this.improve!=''){
        // alert("v-switch",this.improve.leg_regulation|JSON);
      //}
      
    },
    toggleChange(bundle){
      //alert(this.improve.no_of_users);
      let bindingList = {20:400,50:800,100:1300,250:2600,500:4000};
      let bindingListChange = {20:135,50:200,100:435,250:865,500:1335};
      //this.improve.annual_price = '';
      if(!bundle){
         this.improve.all_content = false;
         this.total = this.total-1;
      }else{
         this.total = this.total+1;
         if(this.total==6){
            this.improve.all_content = true;
         }
      }
      if(this.total>5){
        this.improve.annual_price = bindingList[this.improve.no_of_users];
      }else{
        this.improve.annual_price = bindingListChange[this.improve.no_of_users]*this.total;
      }
      
      //alert(this.improve.no_of_users);
      //changePrice(this.improve.no_of_users,this.improve);
    },
    showCompanyList() {
      if(this.partner.partner_level==2) {
        this.isLevelTier2 = true
        this.partner.commission=15
      } else {
        this.isLevelTier2 = false;
        this.partner.commission=25
      }
    },
    getPartnerCompanyList() {
      partnerAPI.getPartnerByTier(1).then(response => {
        this.partnerCompanyList = response.data.data;
      });
    }
  }
};
</script>
